import Home from "features/forestage/Home";
import {
  List as RoleList,
  Create as RoleCreate,
  Edit as RoleEdit,
} from "features/backstage/Roles";
import {
  List as UserList,
  Create as UserCreate,
  Detail as UserDetail,
  Edit as UserEdit,
  ResetPassword as UserResetPassword,
} from "features/backstage/Users";
import Login from "features/backstage/Login";
import LogList from "features/backstage/Logs";
import {
  List as CategoryList,
  Create as CategoryCreate,
  Edit as CategoryEdit,
} from "features/backstage/Categories";
import {
  List as ChartList,
  Create as ChartCreate,
  Edit as ChartEdit,
} from "features/backstage/Charts";
import CityInfoUpdateDate from "features/backstage/CityInfoUpdateDate";
import ViewsCount from "features/backstage/ViewsCount";
import BackstageLayout from "features/backstage/_shared/Layout";

import { Detail as FrontCategoryDetail } from "features/forestage/Categories";
import { Detail as FrontChartDetail } from "features/forestage/Charts";
import HotBoard from "features/forestage/HotBoard";
import Error from "features/forestage/Error";
import ForestageLayout from "features/forestage/_shared/Layout";

export const FUNCTIONS_URL = "/functions";

const routes = [
  {
    Component: Login,
    path: "/login",
  },
  {
    Component: HotBoard,
    path: "/hotboard",
  },
  {
    Component: ForestageLayout,
    path: "/",
    routes: [
      {
        index: true,
        Component: Home,
        path: "/",
      },
      {
        Component: FrontCategoryDetail,
        path: `/categories/:id`,
      },
      {
        Component: FrontChartDetail,
        path: "/charts/:id",
      },
      { path: "*", Component: Error },
    ],
  },
  {
    Component: BackstageLayout,
    path: FUNCTIONS_URL,
    routes: [
      {
        Component: RoleList,
        path: `${FUNCTIONS_URL}/roles`,
      },
      {
        Component: RoleCreate,
        path: `${FUNCTIONS_URL}/roles/new`,
      },
      {
        Component: RoleEdit,
        path: `${FUNCTIONS_URL}/roles/:id/edit`,
      },
      {
        Component: UserList,
        path: `${FUNCTIONS_URL}/users`,
      },
      {
        Component: UserCreate,
        path: `${FUNCTIONS_URL}/users/new`,
      },
      {
        Component: UserDetail,
        path: `${FUNCTIONS_URL}/users/:id`,
      },
      {
        Component: UserEdit,
        path: `${FUNCTIONS_URL}/users/:id/edit`,
      },
      {
        Component: UserResetPassword,
        path: `${FUNCTIONS_URL}/users/:id/reset-password`,
      },
      {
        Component: LogList,
        path: `${FUNCTIONS_URL}/logs`,
      },
      {
        Component: CategoryList,
        path: `${FUNCTIONS_URL}/categories`,
      },
      {
        Component: CategoryCreate,
        path: `${FUNCTIONS_URL}/categories/new`,
      },
      {
        Component: CategoryEdit,
        path: `${FUNCTIONS_URL}/categories/:id/edit`,
      },
      {
        Component: ChartList,
        path: `${FUNCTIONS_URL}/charts`,
      },
      {
        Component: ChartCreate,
        path: `${FUNCTIONS_URL}/charts/new`,
      },
      {
        Component: ChartEdit,
        path: `${FUNCTIONS_URL}/charts/:id/edit`,
      },
      {
        Component: CityInfoUpdateDate,
        path: `${FUNCTIONS_URL}/city-info-update-date`,
      },
      {
        Component: ViewsCount,
        path: `${FUNCTIONS_URL}/views-count`,
      },
      { path: "*", Component: Error },
    ],
  },
];

export default routes;
